module.exports = __webpack_public_path__ + "img/xxx.5b66d5e.png";